import { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";

import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import DailyCheckInListHistory from "./DailyCheckInListHistory";
import DailyCheckInListRuleSetting from "./DailyCheckInListRuleSetting";
import DailyCheckInUpdateRuleSetting from "./DailyCheckInUpdateRuleSetting";

import {
  getDailyCheckInHistory,
  getDailyCheckInRuleSetting,
} from "../../store/ducks/dailyCheckIn/actions";

const initialFilteringState = {
  start_date: "",
  end_date: "",
  member: "",
  date: "",
};

class DailyCheckIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabId: "HISTORY", // HISTORY | RULE_SETTING | UPDATE_RULE_SETTING
      ruleSetting: null,
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    if (
      prevProps.listHistory !== this.props.listHistory &&
      this.props.listHistory
    ) {
      const { responseCode, data } = this.props.listHistory?.data;
      if (responseCode === 200 && data) {
        this.setState({
          dataCheckInHistory: data?.result?.row,
          totalRecords: data?.result?.pagination?.total_record,
          loading: false,
        });
      }
    }

    if (
      prevProps.listRuleSetting !== this.props.listRuleSetting &&
      this.props.listRuleSetting
    ) {
      const { responseCode, data } = this.props.listRuleSetting?.data;
      if (responseCode === 200 && data) {
        this.setState({
          dataCheckInRuleSetting: data?.result?.row,
          totalRecords: data?.result?.pagination?.total_record,
          loading: false,
        });
      }
    }
  }

  onChangeTabIdHandler = (event, tabId, data) => {
    event?.preventDefault(); // prevents page reload

    this.setState({ tabId }, () => {
      switch (tabId) {
        case "UPDATE_RULE_SETTING":
          this.setState({
            ...this.state,
            ruleSetting: data
          });
          break;
        default:
          break;
      }
    });
  };

  onInputChange(event) {
    // console.log(event.target.id+' | '+event.target.value);
    let newFilter = Object.assign({}, this.state.filterInput);
    if (event.target.id === "transaction_date") {
      const date =
        event.target.value !== "" ? event.target.value.split(" - ") : null;
      newFilter["start_date"] = date ? date[0] : "";
      newFilter["end_date"] = date ? date[1] : "";
      newFilter["date"] = event.target.value;
    } else {
      newFilter[event.target.id] = event.target.value;
    }
    this.setState({
      filterInput: newFilter,
    });
  }

  clearHandler = () => {
    let newFilter = initialFilteringState;
    this.setState(
      {
        activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
        limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
        searchValue: "",
        order: "",
        filterInput: newFilter,
        loading: true,
        data: [],
      },
      () => {
        const listingArr = this.fetchData();
        this.props.getDailyMission(listingArr);
      }
    );
  };

  refreshHandler = () => {
    this.setState(
      {
        loading: true,
        data: [],
        activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
        order: "",
      },
      () => {
        const listingArr = this.fetchData();
        this.props.getDailyMission(listingArr);
      }
    );
  };

  // go to transaction details
  detailsHandler = (e, id) => {
    e.preventDefault();
    this.setState({
      pageShow: "details",
      detailsParam: {
        id: id,
      },
    });
  };

  changePageHandler = (page) => {
    this.setState({
      pageShow: page,
    });
  };

  datatablesChangeHandler = (val, act) => {
    this.setState(
      {
        [act]: act === "searchValue" ? val.target.value : val,
        loading: true,
        data: [],
      },
      () => {
        const listingArr = this.fetchData();
        this.props.getDailyMission(listingArr);
      }
    );
  };

  onSort = (field, order) => {
    const orderArry = [{}];
    let orderSequence = order === "asc" ? true : false;

    orderArry[0]["id"] = field;
    orderArry[0]["desc"] = orderSequence;

    this.setState(
      {
        order: orderArry,
        loading: true,
        data: [],
      },
      () => {
        const listingArr = this.fetchData();
        this.props.getDailyMission(listingArr);
      }
    );
  };

  noFormatter = (cell, row, rowIndex) => {
    let rowNumber =
      this.state.totalRecords -
      rowIndex -
      (this.state.activePage - 1) * this.state.limit;
    return <span>{rowNumber}</span>;
  };

  render() {
    const { t } = this.props;

    return (
      <Auxiliary>
        {(this.state.tabId === "HISTORY" ||
          this.state.tabId === "RULE_SETTING") && (
          <>
            <div className="row">
              <div className="col-md-12">
                <div className="panel panel-primary tabs-style-2 mt-3">
                  <div className="tab-menu-heading">
                    <div className="tabs-menu1">
                      <ul className="nav panel-tabs main-nav-line">
                        <li>
                          <a
                            href="/#"
                            id="total_deposit_turnover"
                            onClick={(e) =>
                              this.onChangeTabIdHandler(e, "HISTORY")
                            }
                            style={{ borderTopWidth: 0 }}
                            className={`nav-link bg-white ${
                              this.state.tabId === "HISTORY" ? "active" : ""
                            }`}
                          >
                            {t("global.daily-check-in-history")}
                          </a>
                        </li>
                        <li>
                          <a
                            href="/#"
                            id="level_tracker_listing"
                            onClick={(e) =>
                              this.onChangeTabIdHandler(e, "RULE_SETTING")
                            }
                            style={{ borderTopWidth: 0 }}
                            className={`nav-link bg-white ${
                              this.state.tabId === "RULE_SETTING"
                                ? "active"
                                : ""
                            }`}
                          >
                            {t("global.daily-check-in-rule-setting")}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </>
        )}

        {this.state.tabId === "HISTORY" && <DailyCheckInListHistory />}

        {this.state.tabId === "RULE_SETTING" && <DailyCheckInListRuleSetting 
            onChangeTabIdHandler={this.onChangeTabIdHandler}
        />}

        {this.state.tabId === "UPDATE_RULE_SETTING" && (
          <DailyCheckInUpdateRuleSetting
            onChangeTabIdHandler={this.onChangeTabIdHandler}
            ruleSetting={this.state.ruleSetting}
            permission={this.props.currentUser?.permission}
            currentUser={this.props.currentUser}
          />
        )}
      </Auxiliary>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getDailyCheckInHistory: (data) => dispatch(getDailyCheckInHistory(data)),
    getDailyCheckInRuleSetting: (data) =>
      dispatch(getDailyCheckInRuleSetting(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    currentUser: state.currentUser.data,
    currentPermission: state.currentUser.data.permission,
    listHistory: state.dailyCheckIn.listHistory,
    listRuleSetting: state.dailyCheckIn.listRuleSetting,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces("translation")(DailyCheckIn));
